// common-components.js
// import { createApp } from 'vue';
import GoTop from "../GoTop";
import Footer from "../Footer";
import Header from "../Header";
import Customer from "@/components/Customer";

export default {
  install(app) {
    app.component("GoTop", GoTop);
    app.component("Footer", Footer);
    app.component("Header", Header);
    app.component("Customer",Customer);
  },
};
